import { CSSProperties } from 'react';
import QRCode from 'qrcode.react';
import { useReduxState } from 'hooks';

import type { Course } from 'shared-types';

interface Props {
  course: Pick<Course, 'slug'>;
  padding?: number;
  size?: number;
  style?: CSSProperties;
}

const CourseQRCode = ({ course, size = 216, padding, style }: Props) => {
  const { serverConfig } = useReduxState();

  return (
    <div className="qr-code" style={style}>
      <div className="code" style={{ padding: padding || 20 }}>
        <QRCode
          renderAs="svg"
          size={size}
          value={`${serverConfig.adminUrl}/courses/${course.slug}`}
        />
      </div>

      <style jsx>{`
        .code {
          background-color: white;
          border-radius: 10px;
          display: inline-block;
        }
      `}</style>
    </div>
  );
};

export default CourseQRCode;
